<template lang="pug">
  v-container#specifics(fluid)
    h1.form-title.dark-text Datos específicos
    v-layout.py-3(row wrap)
      v-container(xs-12 fluid)
        v-layout.py-1(row wrap)
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['ageGroup']"
              v-model="ageGroup"
              ref="Grupo de Edad"
              label="Grupo de Edad"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['ethnicGroup']"
              v-model="ethnicGroup"
              ref="Grupo étnico"
              label="Grupo étnico"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="ethnicGroup == 'Otro'")
            v-text-field(
              v-model="ethnicGroupOther"
              ref="¿Cuál grupo étnico?"
              label="¿Cuál grupo étnico?"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['education']"
              v-model="education"
              ref="Nivel educativo"
              label="Nivel educativo"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="education == 'Otro'")
            v-text-field(
              v-model="educationOther"
              ref="¿Cuál nivel educativo?"
              label="¿Cuál nivel educativo?"
              menu-props="auto"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['bornSex']"
              v-model="bornSex"
              ref="Sexo asignado al nacer"
              label="Sexo asignado al nacer"
              menu-props="auto"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['precedents']"
              v-model="precedents"
              ref="Antecedente de violencia"
              label="Antecedente de violencia"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="precedents == 'Otro'")
            v-text-field(
              v-model="precedentsOther"
              ref="¿Qué antecedentes?"
              label="¿Qué antecedentes?"
              menu-props="auto"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['weapon']"
              v-model="weapon"
              ref="Arma"
              label="Arma"
              menu-props="auto"
            )
            v-icon.visible(v-if="weaponVisible" @click="visible('weapon')") visibility
            v-icon.visible(v-if="!weaponVisible" @click="visible('weapon')") visibility_off
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="weapon == 'Otro'")
            v-text-field(
              v-model="weaponOther"
              ref="Tipo de arma"
              label="Tipo de arma"
              menu-props="auto"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['bodyState']"
              v-model="bodyState"
              ref="Estado del cuerpo"
              label="Estado del cuerpo"
              menu-props="auto"
            )
            v-icon.visible(v-if="bodyStateVisible" @click="visible('bodyState')") visibility
            v-icon.visible(v-if="!bodyStateVisible" @click="visible('bodyState')") visibility_off
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="bodyState == 'Otro'")
            v-text-field(
            v-model="bodyStateOther"
            ref="¿Cuál fue el estado del cuerpo?"
            label="¿Cuál fue el estado del cuerpo?"
            menu-props="auto"
          )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="investigation"
              ref="Averiguación previa"
              label="Averiguación previa"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['lineOfInvestigation']"
              v-model="lineOfInvestigation"
              ref="Línea de investigación"
              label="Línea de investigación"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="lineOfInvestigation == 'Otro'")
            v-text-field(
            v-model="lineOfInvestigationOther"
            ref="¿Qué línea de investigación?"
            label="¿Qué línea de investigación?"
            menu-props="auto"
          )
        v-layout.py-1(row wrap)
          v-flex.pa-2.mr-3.light-background
            v-flex(d-flex xs12)
              v-select(
                :items="options['yesNo']"
                v-model="sexualViolence"
                label="¿Hubo indicios de violencia sexual?"
                menu-props="auto"
              )
              v-icon.visible(v-if="sexualViolenceVisible" @click="visible('sexualViolence')") visibility
              v-icon.visible(v-if="!sexualViolenceVisible" @click="visible('sexualViolence')") visibility_off
            v-text-field(
              v-model="sexualViolenceDetails"
              ref="Especificar"
              label="Especificar"
            )
          v-flex.pa-2.mr-3.light-background
            v-flex(d-flex xs12)
              v-select(
                :items="options['yesNo']"
                ref="¿Hubo indicios de ensañamiento?"
                v-model="tortureViolence"
                label="¿Hubo indicios de ensañamiento?"
              )
              v-icon.visible(v-if="tortureViolenceVisible" @click="visible('tortureViolence')") visibility
              v-icon.visible(v-if="!tortureViolenceVisible" @click="visible('tortureViolence')") visibility_off
            v-text-field(
              v-model="tortureViolenceDetails"
              ref="Especificar"
              label="Especificar"
            )
          v-flex.pa-2.mr-3.light-background
            v-flex(d-flex xs12)
              v-select(
                :items="options['yesNo']"
                ref="¿Hubo detenidos?"
                v-model="wasOffenderFound"
                label="¿Hubo detenidos?"
              )
              v-icon.visible(v-if="wasOffenderFoundVisible" @click="visible('wasOffenderFound')") visibility
              v-icon.visible(v-if="!wasOffenderFoundVisible" @click="visible('wasOffenderFound')") visibility_off
            v-text-field(
              v-model="wasOffenderFoundDetails"
              ref="Especificar"
              label="Especificar"
            )
        v-layout.py-1(row wrap)
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['offenderStatus']"
              v-model="offenderStatus"
              ref="Estado del proceso"
              label="Estado del proceso"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="offenderStatus == 'Otro'")
            v-text-field(
              v-model="offenderStatusOther"
              ref="¿Cuál es el estado del proceso?"
              label="¿Cuál es el estado del proceso?"
              menu-props="auto"
            )

          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="offenderName"
              ref="Nombre del victimario"
              label="Nombre del victimario"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="offenderAge"
              ref="Edad del victimario"
              label="Edad del victimario"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['ageGroup']"
              v-model="offenderAgeGroup"
              ref="Grupo de edad del victimario"
              label="Grupo de edad del victimario"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              :items="options['offenderRelationship']"
              v-model="offenderRelationship"
              ref="Relación con la víctima"
              label="Relación con la víctima"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4 v-if="offenderRelationship == 'Otro'")
            v-text-field(
              v-model="offenderRelationshipOther"
              ref="¿Cuál era la relación?"
              label="¿Cuál era la relación?"
              menu-props="auto"
            )
          
</template>
<script>
export default {
  name: "Specifics",
  props: {},
  data() {
    return {
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    weaponVisible: {
      get() {
        return this.$store.state.record.weaponVisible;
      },
      set(value) {
        this.$store.commit("updateWeaponVisible", value);
      }
    },
    bodyStateVisible: {
      get() {
        return this.$store.state.record.bodyStateVisible;
      },
      set(value) {
        this.$store.commit("updateBodyStateVisible", value);
      }
    },
    sexualViolenceVisible: {
      get() {
        return this.$store.state.record.sexualViolenceVisible;
      },
      set(value) {
        this.$store.commit("updateSexualViolenceVisible", value);
      }
    },
    tortureViolenceVisible: {
      get() {
        return this.$store.state.record.tortureViolenceVisible;
      },
      set(value) {
        this.$store.commit("updateTortureViolenceVisible", value);
      }
    },
    wasOffenderFoundVisible: {
      get() {
        return this.$store.state.record.wasOffenderFoundVisible;
      },
      set(value) {
        this.$store.commit("updateWasOffenderFoundVisible", value);
      }
    },
    ageGroup: {
      get() {
        return this.$store.state.record.ageGroup;
      },
      set(value) {
        this.$store.commit("updateAgeGroup", value);
      }
    },
    ethnicGroup: {
      get() {
        return this.$store.state.record.ethnicGroup;
      },
      set(value) {
        this.$store.commit("updateEthnicGroup", value);
      }
    },
    ethnicGroupOther: {
      get() {
        return this.$store.state.record.ethnicGroupOther;
      },
      set(value) {
        this.$store.commit("updateEthnicGroupOther", value);
      }
    },
    education: {
      get() {
        return this.$store.state.record.education;
      },
      set(value) {
        this.$store.commit("updateEducation", value);
      }
    },
    educationOther: {
      get() {
        return this.$store.state.record.educationOther;
      },
      set(value) {
        this.$store.commit("updateEducationOther", value);
      }
    },
    bornSex: {
      get() {
        return this.$store.state.record.bornSex;
      },
      set(value) {
        this.$store.commit("updateBornSex", value);
      }
    },
    precedents: {
      get() {
        return this.$store.state.record.precedents;
      },
      set(value) {
        this.$store.commit("updatePrecedents", value);
      }
    },
    precedentsOther: {
      get() {
        return this.$store.state.record.precedentsOther;
      },
      set(value) {
        this.$store.commit("updatePrecedentsOther", value);
      }
    },
    weapon: {
      get() {
        return this.$store.state.record.weapon;
      },
      set(value) {
        this.$store.commit("updateWeapon", value);
      }
    },
    weaponOther: {
      get() {
        return this.$store.state.record.weaponOther;
      },
      set(value) {
        this.$store.commit("updateWeaponOther", value);
      }
    },
    bodyState: {
      get() {
        return this.$store.state.record.bodyState;
      },
      set(value) {
        this.$store.commit("updateBodyState", value);
      }
    },
    bodyStateOther: {
      get() {
        return this.$store.state.record.bodyStateOther;
      },
      set(value) {
        this.$store.commit("updateBodyStateOther", value);
      }
    },
    investigation: {
      get() {
        return this.$store.state.record.investigation;
      },
      set(value) {
        this.$store.commit("updateInvestigation", value);
      }
    },
    lineOfInvestigation: {
      get() {
        return this.$store.state.record.lineOfInvestigation;
      },
      set(value) {
        this.$store.commit("updateLineOfInvestigation", value);
      }
    },
    lineOfInvestigationOther: {
      get() {
        return this.$store.state.record.lineOfInvestigationOther;
      },
      set(value) {
        this.$store.commit("updateLineOfInvestigationOther", value);
      }
    },
    sexualViolence: {
      get() {
        return this.$store.state.record.sexualViolence;
      },
      set(value) {
        this.$store.commit("updateSexualViolence", value);
      }
    },
    sexualViolenceDetails: {
      get() {
        return this.$store.state.record.sexualViolenceDetails;
      },
      set(value) {
        this.$store.commit("updateSexualViolenceDetails", value);
      }
    },
    tortureViolence: {
      get() {
        return this.$store.state.record.tortureViolence;
      },
      set(value) {
        this.$store.commit("updateTortureViolence", value);
      }
    },
    tortureViolenceDetails: {
      get() {
        return this.$store.state.record.tortureViolenceDetails;
      },
      set(value) {
        this.$store.commit("updateTortureViolenceDetails", value);
      }
    },
    wasOffenderFound: {
      get() {
        return this.$store.state.record.wasOffenderFound;
      },
      set(value) {
        this.$store.commit("updateWasOffenderFound", value);
      }
    },
    wasOffenderFoundDetails: {
      get() {
        return this.$store.state.record.wasOffenderFoundDetails;
      },
      set(value) {
        this.$store.commit("updateWasOffenderFoundDetails", value);
      }
    },
    offenderStatus: {
      get() {
        return this.$store.state.record.offenderStatus;
      },
      set(value) {
        this.$store.commit("updateOffenderStatus", value);
      }
    },
    offenderStatusOther: {
      get() {
        return this.$store.state.record.offenderStatusOther;
      },
      set(value) {
        this.$store.commit("updateOffenderStatusOther", value);
      }
    },
    offenderName: {
      get() {
        return this.$store.state.record.offenderName;
      },
      set(value) {
        this.$store.commit("updateOffenderName", value);
      }
    },
    offenderAge: {
      get() {
        return this.$store.state.record.offenderAge;
      },
      set(value) {
        this.$store.commit("updateOffenderAge", value);
      }
    },
    offenderAgeGroup: {
      get() {
        return this.$store.state.record.offenderAgeGroup;
      },
      set(value) {
        this.$store.commit("updateOffenderAgeGroup", value);
      }
    },
    offenderRelationship: {
      get() {
        return this.$store.state.record.offenderRelationship;
      },
      set(value) {
        this.$store.commit("updateOffenderRelationship", value);
      }
    },
    offenderRelationshipOther: {
      get() {
        return this.$store.state.record.offenderRelationshipOther;
      },
      set(value) {
        this.$store.commit("updateOffenderRelationshipOther", value);
      }
    }
  },
  methods: {
    visible(item) {
      switch (item) {
        case 'weapon':
          this.weaponVisible = !this.weaponVisible;
          break;
        case 'bodyState':
          this.bodyStateVisible = !this.bodyStateVisible;
          break;
        case 'sexualViolence':
          this.sexualViolenceVisible = !this.sexualViolenceVisible;
          break;
        case 'tortureViolence':
          this.tortureViolenceVisible = !this.tortureViolenceVisible;
          break;
        case 'wasOffenderFound':
          this.wasOffenderFoundVisible = !this.wasOffenderFoundVisible;
          break;
      }
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="scss">
</style>
